import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";


export type Offre = {
  [index: string]: any;
  titre: string;
  description: string;
  adresse: string;
  localisation?: string;
  nombreDeJours?: number;
  dateDemarrageSouhaiter?: string;
  budget?: number;
  avecMateriel?: boolean;
  devis?: boolean,
  previsite?: boolean,
  contrat?: boolean;
  paiementGrouilleur: "JOURNEE" | "TACHE";
  idGrouilleur?: number;
  idGrouilleurDePreference?: number;
  idSousCategorie?: number;
  idCategorie?: number;
  fichierJoints?: any;
};

export declare interface OffreState {
  [index: string]: any;
}
const initialState: OffreState = {};

export const offreSlice = createSlice({
  initialState,
  name: "offre",
  reducers: {
    createOffre: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listOffre: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeOffre: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateOffre: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createOffre,
  listOffre,
  removeOffre,
  updateOffre,
} = offreSlice.actions;

export const createAsyncOffre =
  (data: Offre, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}V2/offre`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncOffre());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create offre error", error);
      onError?.();
    }
  };

export const listAsyncOffre =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}offre/admin-all?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      
      if (res.data.length) {
        dispatch(listOffre(res.data));
      }
    } catch (error) {
      console.log("list offre error", error);
      // onError?.();
    }
  };

export const listAsyncOffreByBoss =
  (bossID: string, callback: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}offre/admin-all/by-boss/${bossID}?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      if (res.data?.length) {
        callback?.(res.data)
      }
    } catch (error) {
      console.log("list offre by boss error", error);
      // onError?.();
    }
  };

  export const getAsyncOffre =
  (offreID: string, callback: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}offre/${offreID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      callback?.(res)
  
    } catch (error) {
      console.log("list offre by boss error", error);
      // onError?.();
    }
  };  

export default offreSlice.reducer as Reducer<OffreState>;
